import {Inject, Injectable} from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {CountedAndPaginated} from "../interface/response/counted-and-paginated";
import {ReceivablesImportRow} from "../interface/receivables-import-row";
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {FilterService} from "./filter.service";
import {DOCUMENT} from "@angular/common";
import {first, take} from "rxjs/operators";
import {CommissionImportRow} from "../interface/commission-import-row";
import {Post} from "../interface/post";
import {Uuid} from "../interface/response/uuid";

@Injectable({
  providedIn: 'root'
})
export class ReceivablesImportsRowService {
  public readonly rowListSubject: ReplaySubject<CountedAndPaginated<ReceivablesImportRow>>
    = new ReplaySubject<CountedAndPaginated<ReceivablesImportRow>>(1);
  public readonly rowListAddSubject: ReplaySubject<CountedAndPaginated<ReceivablesImportRow>>
    = new ReplaySubject<CountedAndPaginated<ReceivablesImportRow>>(1);

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
    @Inject(DOCUMENT) private document: Document
  ) { }

  public loadList(page: number, pageSize: number, filters: object, serviceKey?: string,
                  sort?: { sortBy?: string, sortOrder?: string }): void
  {
    this.httpClient.get(`/rest/crm/receivables-import-row${serviceKey}?page=${page + 1}&pageSize=${pageSize}&sortBy=${sort.sortBy ?? ''}&sortOrder=${sort.sortOrder ?? ''}&`
      + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe({
        next: (result: CountedAndPaginated<ReceivablesImportRow>) => {
          this.rowListSubject.next(result);
        }, error: (error: HttpErrorResponse) => {
          this.rowListSubject.error(error);
        }
      });
  }

  public loadListAdd(page: number, pageSize: number, filters: object, serviceKey?: string,
                  sort?: { sortBy?: string, sortOrder?: string }): void
  {
    this.httpClient.get(`/rest/crm/receivables-import-row${serviceKey}?page=${page + 1}&pageSize=${pageSize}&sortBy=${sort.sortBy ?? ''}&sortOrder=${sort.sortOrder ?? ''}&`
      + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe({
        next: (result: CountedAndPaginated<ReceivablesImportRow>) => {
          this.rowListAddSubject.next(result);
        }, error: (error: HttpErrorResponse) => {
          this.rowListAddSubject.error(error);
        }
      });
  }

  public get(receivablesImportRowId: string): Observable<ReceivablesImportRow> {
    return this.httpClient.get(`/rest/crm/receivables-import-row/${receivablesImportRowId}`)
      .pipe(first()) as Observable<ReceivablesImportRow>;
  }

  downloadReport(filters: any, serviceKey?: string): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/receivables-import-row${serviceKey}/method/report?` + this.filterService.parseFilters(filters), {})
      .pipe(first()) as Observable<Uuid>;
  }

  cancelRow(rowId: string, reason?: string , status?: number , fileContent?: string , fileName?: string ): Observable<any> {
    return this.httpClient.post(`/rest/crm/receivables-import-row/cancel/${rowId}`, {
      status: status,
      note: reason,
      fileContent: fileContent,
      fileName: fileName

    })
          .pipe(take(1));
  }

  newRow(rowId: string, status: number): Observable<any> {
    return this.httpClient.post(`/rest/crm/receivables-import-row/new/${rowId}`,
      {
        status: status,
      })
        .pipe(take(1));
  }

  verificationRow(rowId: string, status: number): Observable<any> {
    return this.httpClient.post(`/rest/crm/receivables-import-row/verification/${rowId}`,
      {
        status: status,
      })
      .pipe(take(1));
  }

  public changeRegistration(formData: any, uuid: string): Observable<any> {
    return this.httpClient.post(`/rest/crm/receivables-import-row/${uuid}/changeRegistration`, formData)
      .pipe(first());
  }

  public policyOverride(formData: any, uuid: string): Observable<any> {
    return this.httpClient.post(`/rest/crm/receivables-import-row/${uuid}/policyOverride`, formData)
      .pipe(first());
  }

  public downloadDocument(rowId: string): void {
    this.document.location.href = `/rest/crm/receivables-import-row/${rowId}/downloadFile`;
  }
}
